import { createBodyFont } from './createBodyFont'
import { createHeadingFont } from './createHeadingFont'

export const fonts = {
  heading: createHeadingFont(),
  body: createBodyFont(),
}
